
import { Suspense } from 'react';
import { Route, Router, Switch } from "react-router-dom";
import { history } from '../_helpers';
import routes, { privateRoutes } from './routes';
import { PrivateRoute } from '../components/private-route';
import SFooter from './SFooter';
import SHeader from './SHeader';
import SLogin from './SLogin';

const loading = <h3>Loading...</h3>;

const SLayout = (props: any) => {
  return (
    <Router history={history}>
      <section className="corporate-booking-expand">
        <SHeader />
        {/* <div className="container-top d-none d-sm-block"></div> */}
        <Suspense fallback={loading}>
          {/* <SSidebar/> */}
          <Switch>
            <div className="marin-left-15">
              {routes.map(({ path, component }, key) => {
                return <Route exact key={key} path={path} component={component}/>
              })}
              {privateRoutes.map(({ path, component, showLogin }, key) => {
                return <PrivateRoute exact key={key} path={path} component={component} showLogin={showLogin} />
              })}
            </div>
          </Switch>
        </Suspense>
        <SLogin />
        <SFooter />
      </section>
    </Router>
  )
};


export default SLayout;
